import { vElementHover, vOnClickOutside } from "@vueuse/components"

import { createPopper } from "@popperjs/core"

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive("element-hover", vElementHover)
  nuxtApp.vueApp.directive("click-outside", vOnClickOutside)
  nuxtApp.vueApp.directive("autofocus", {
    mounted(el, { value }) {
      if (value === true || value === undefined) {
        el.focus()
      }
    },
  })

  nuxtApp.vueApp.directive("overflow", {
    created(el, { value }) {
      const baseStyle = " text-overflow:ellipsis; white-space:nowrap; overflow: hidden"
      el.style += baseStyle

      // 50 is the level of the app dropdowns: above the sticky table header (10) and total row, and
      // below the modals (100) and the global search (110).
      const activeStyle = `
        position: absolute;
        z-index: 50;
        color: ${value?.theme === "light" ? "#374151" : "white"};
        background-color: ${value?.theme === "light" ? "white" : "#374151"};
        box-shadow: 0 2px 8px rgb(0 0 0 / 15%);
        overflow: visible;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
        border-radius: 0.25rem;
      `

      let popperInstance: undefined | ReturnType<typeof createPopper>

      const elementId = "overflow-directive"

      function close() {
        if (popperInstance) {
          popperInstance.destroy()
        }
        document.getElementById(elementId)?.remove()
      }

      el.addEventListener("mouseenter", (evt: any) => {
        const targetEl = evt.target
        const tolerance = 1
        const isOverflowing =
          targetEl.clientWidth + tolerance < targetEl.scrollWidth ||
          targetEl.clientHeight + tolerance < targetEl.scrollHeight

        if (isOverflowing) {
          // Prepending a new div with an absolute position to display the data because of flex container issues.
          const popperEl = document.createElement("div")
          popperEl.id = elementId

          popperInstance = createPopper(el, popperEl, { placement: "top" })
          popperEl.setAttribute("style", activeStyle)

          popperEl.innerHTML = el.innerHTML // same content
          el.prepend(popperEl)

          // Delete also when mouseenter the popup
          popperEl.addEventListener("mouseenter", close)
        }
      })

      el.addEventListener("mouseleave", close)
    },
  })
})
